import * as React from 'react';

import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import * as inputUtils from '../inputUtils';
import InputContainer from '../InputContainer/InputContainer';

interface EmailInputProps {
  showMatchIndicator?: boolean;
  hideIcon?: boolean;
  hidePlaceholder?: boolean;
}

class EmailInput extends React.Component<InputProps & EmailInputProps, {}> {
  private inputWrapperRef = React.createRef<HTMLDivElement>();

  render() {
    const { input, placeholder, hideIcon, hidePlaceholder, meta, showMatchIndicator, disabled, label } = this.props;
    const name = input.name;
    const identifier = placeholder || 'Email address';
    const emailsMatch = !meta.error;
    const error = meta.touched && meta.error;
    const ariaProps = inputUtils.getAriaProps(name, !!error);
    const inputStatus = (() => {
      if (showMatchIndicator && meta.active) {
        return emailsMatch ? 'match' : 'mismatch';
      }
      return null;
    })();

    return (
      <InputContainer
        icon={hideIcon ? undefined : 'email-2'}
        error={error}
        active={meta.active}
        status={inputStatus}
        name={name}
        label={label}
        identifier={identifier}
      >
        <div ref={this.inputWrapperRef} className="EmailInput-inputWrapper">
          <input
            type="email"
            autoComplete="off"
            disabled={disabled}
            {...ariaProps}
            {...input}
            required
            id={getIdFromName(name)}
            name={name}
            placeholder={hidePlaceholder ? null : identifier}
          />
        </div>
      </InputContainer>
    );
  }
}

export const EmailInputConfig = {
  component: EmailInput,
};

export const EmailInputWithMatchConfig = {
  component: props => <EmailInput showMatchIndicator {...props} />,
};

export default EmailInput;
